export const environment = {
  production: true,
  apiHost: "https://api.mediamonorail-qa.com",
  signInUrl: "https://api.mediamonorail-qa.com/authorize",
  connectUrl: "https://mediamonorail-qa.com/assets/connect/v4",
  version: require('../../package.json').version,
  monorailV4URL: "https://v4.mediamonorail-qa.com",
  datadogRumEnv: "qa"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts